import { isEmpty, omitBy, without } from 'lodash';
import { NEWSLETTER_SUBMIT_SUBSCRIPTION } from 'Utils/request/requestDictionary';

import gqlClient from 'Utils/graphql-client/graphqlClient';
import { attributesToString } from 'Utils/graphql-client/graphqlClient.utils';

function filterObjectWithMapping(data) {
  const rules = {
    email: 'email',
    civility: 'gender',
    firstName: 'firstName',
    lastName: 'lastName',
    unicodeFirstName: 'unicodeFirstName',
    unicodeLastName: 'unicodeLastName',
    subscriptions: 'newsletterSubscriptions',
    conditions: 'legalInformations',
  };

  return Object.keys(data).reduce((result, currentAttribute) => {
    const mappedField = rules[currentAttribute];
    if (!isEmpty(mappedField)) {
      result[mappedField] = data[currentAttribute];
    }
    return result;
  }, {});
}

const LIST_INPUTS = [
  'civility',
  'firstName',
  'lastName',
  'email',
  'unicodeFirstName',
  'unicodeLastName',
];

export const formatedData = values => {
  const subscriptions = Object.keys(omitBy(values, value => value === false));
  return {
    ...values,
    subscriptions: without(subscriptions, ...LIST_INPUTS),
  };
};

export function submitSubscriptionForm({ appContext, subscriptionId, data = {}, isSubscription }) {
  const filteredData = filterObjectWithMapping(data);

  if (!isEmpty(subscriptionId)) {
    filteredData.subscriptionId = subscriptionId;
  }
  filteredData.isSubscription = isSubscription;

  const selection = attributesToString(filteredData);
  return gqlClient.runNoCacheQuery(
    `mutation RootMutationType {subscription (${selection}) { id neolaneId error { errorDescription }}}`,
    appContext,
    { requestName: NEWSLETTER_SUBMIT_SUBSCRIPTION },
  );
}
